export default __webpack_public_path__ + "svg/CompaniesLogos/logo_adigital.svg?acd97990";